// extracted by mini-css-extract-plugin
export var spinner = "Spinner-module--spinner--1VvGO";
export var loaderSpinner = "Spinner-module--loader-spinner--1stri";